var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isDscDebug ? _c('d-s-c-debug', {
    attrs: {
      "controller": _vm.controller
    }
  }) : _c('hikvision-debug', {
    attrs: {
      "controller": _vm.controller
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }